import {DateRange} from 'src/components/filter-header/typedefs';
import {FilterValue} from 'src/hooks/filtered-data/useFilteredData';

type ColumnCriteria<F, C extends keyof F> = {caption: string, type: C};
type DateCriteria<F, C extends keyof F> = {caption: string, type: C, key: 'from' | 'to'};

export const createColumnCriteria = <F extends Record<C, FilterValue>, C extends keyof F>(
    filters: F,
    criteriaData: ColumnCriteria<F, C>[],
    onPillRemove: (name: string, column: C) => void,
) => {
    return criteriaData.map(({caption, type}) => ({
        caption,
        pills: filters[type] as string[],
        onRemove: (name: string) => onPillRemove(name, type),
    }));
};

export const createDateCriteria = <F extends Record<C, FilterValue>, C extends keyof F>(
    filters: F,
    criteriaData: DateCriteria<F, C>[],
    onPillRemove: (filterType: C, filterValue: FilterValue) => void,
) => {
    return criteriaData.map(({caption, type, key}) => {
        const dateRange = filters[type] as DateRange;
        const pill = dateRange[key] ? [String(dateRange[key])] : [];

        return {
            caption,
            pills: pill,
            onRemove: () => onPillRemove(type, {...dateRange, [key]: ''}),
        };
    });
};
